import React, { useEffect, useState } from "react";
import FormikController from "../../../components/FormikController/FormikController";
import { nurseVisitType } from "../../../Constants/Constants";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { headerTextStyles } from "../../../Constants/Styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import { YupValidation } from "../../../Constants/ValidationConstants";
import ClientStore from "../../../Store/ClientStore";
import AgencyStore from "../../../Store/AgencyStore";
import axios from "axios";
import { ClientURL } from "../../../Url/Url";
import ConfirmPopUp from "../../../components/ConfirmPopUp/ConfirmPopUp";
import { useParams } from "react-router-dom";

const AddClientCarePlan = ({ handleClose, type, editData }) => {
  const { clientId } = useParams();
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [saveUpadateState, setSaveUpadateState] = useState("");
  const handlesaveUpadateState = (value) => {
    setSaveUpadateState(value);
  };
  const handleCheckboxChange = (name) => {
    name == "copyOfPlanLeft"
      ? setIsChecked(!isChecked)
      : setIsChecked1(!isChecked1);
  };

  const formik = useFormik({
    initialValues: {
      visitType: "",
      detailedClientFunLimit: "",
      pcaServices: "",
      rnSupervisorVisits: "",
      goalOfServices: "",
      objectivesOfServices: "",
      dischargePlans: "",
      pcaToReport: "",
      otherInstructions: "",

      specificActivitiesAllowed: "",
      transferSpecifics: "",
      equipmentToBeUsed: "",
      safetyNeeds: "",
      bathingSpecifics: "",
      hairCareSpecifics: "",
      dressingSpecifics: "",
      skinCareSpecifics: "",
      nailCareSpecifics: "",
      oralCareSpecifics: "",
      shavingSpecifics: "",
      assistWithEliminationBy: "",
      documentBm: "",
      assistWithMealPrepBy: "",
      remindPatientToTakeMedOf: "",
      cleaningToBePerformed: "",
      houseKeepingSpecifics: "",
      provideTransportationFor: "",
      carToBeUtilized: "",
      shopping: "",
      mealPlanning: "",
      billPaying: "",
      mealPrep: "",

      copyOfPlanLeft: false,
      clientWasInvolved: false,
    },
    validationSchema: Yup.object({
      visitType: YupValidation.requiredOnly,
    }),

    onSubmit: (values) => {
      if (saveUpadateState == "save") {
        saveClientCarePlan(values);
      } else updateClientCarePlan(values);
    },
  });

  const diagnosisData = [];
  ClientStore?.clientDiagnosisAllData?.resultSet?.forEach((item) => {
    diagnosisData.push(item.diagnosis);
  });

  useEffect(() => {
    if (type == "update") {
      setProfileDataFormik();

      setIsChecked(editData?.copyOfPlanLeft);
      setIsChecked1(editData?.clientWasInvolved);
    }
  }, []);
  const saveClientCarePlan = (values) => {
    AgencyStore.setIsLoading(true);
    const params = {
      clientProfileId: clientId,
      visitType: values.visitType,
      detailedClientFunLimit: values.detailedClientFunLimit,
      pcaServices: values.pcaServices,
      rnSupervisorVisits: values.rnSupervisorVisits,
      goalOfServices: values.goalOfServices,
      objectivesOfServices: values.objectivesOfServices,
      dischargePlans: values.dischargePlans,
      ambulation: {
        specificActivitiesAllowed:
          values.specificActivitiesAllowed.trim() === ""
            ? []
            : values.specificActivitiesAllowed.split("\n"),
        transferSpecifics:
          values.transferSpecifics.trim() === ""
            ? []
            : values.transferSpecifics.split("\n"),
        equipmentToBeUsed:
          values.equipmentToBeUsed.trim() === ""
            ? []
            : values.equipmentToBeUsed.split("\n"),
        safetyNeeds:
          values.safetyNeeds.trim() === ""
            ? []
            : values.safetyNeeds.split("\n"),
      },
      personalCare: {
        bathingSpecifics:
          values.bathingSpecifics.trim() === ""
            ? []
            : values.bathingSpecifics.split("\n"),
        hairCareSpecifics:
          values.hairCareSpecifics.trim() === ""
            ? []
            : values.hairCareSpecifics.split("\n"),
        dressingSpecifics:
          values.dressingSpecifics.trim() === ""
            ? []
            : values.dressingSpecifics.split("\n"),
        skinCareSpecifics:
          values.skinCareSpecifics.trim() === ""
            ? []
            : values.skinCareSpecifics.split("\n"),
        nailCareSpecifics:
          values.nailCareSpecifics.trim() === ""
            ? []
            : values.nailCareSpecifics.split("\n"),
        oralCareSpecifics:
          values.oralCareSpecifics.trim() === ""
            ? []
            : values.oralCareSpecifics.split("\n"),
        shavingSpecifics:
          values.shavingSpecifics.trim() === ""
            ? []
            : values.shavingSpecifics.split("\n"),
      },
      elimination: {
        assistWithEliminationBy: values.assistWithEliminationBy,
        documentBm: values.documentBm,
      },
      nutrition: {
        assistWithMealPrepBy: values.assistWithMealPrepBy,
        remindPatientToTakeMedOf:
          values.remindPatientToTakeMedOf.trim() === ""
            ? []
            : values.remindPatientToTakeMedOf.split("\n"),
      },
      lightHouseKeepingTask: {
        cleaningToBePerformed:
          values.cleaningToBePerformed.trim() === ""
            ? []
            : values.cleaningToBePerformed.split("\n"),
        houseKeepingSpecifics:
          values.houseKeepingSpecifics.trim() === ""
            ? []
            : values.houseKeepingSpecifics.split("\n"),
      },
      transportation: {
        provideTransportationFor:
          values.provideTransportationFor.trim() === ""
            ? []
            : values.provideTransportationFor.split("\n"),
        carToBeUtilized:
          values.carToBeUtilized.trim() === ""
            ? []
            : values.carToBeUtilized.split("\n"),
      },
      homeManagement: {
        shopping:
          values.shopping.trim() === "" ? [] : values.shopping.split("\n"),
        mealPlanning:
          values.mealPlanning.trim() === ""
            ? []
            : values.mealPlanning.split("\n"),
        billPaying:
          values.billPaying.trim() === "" ? [] : values.billPaying.split("\n"),
        mealPrep:
          values.mealPrep.trim() === "" ? [] : values.mealPrep.split("\n"),
      },
      pcaToReport: values.pcaToReport,
      otherInstructions: values.otherInstructions,
      copyOfPlanLeft: isChecked,
      clientWasInvolved: isChecked1,
    };
    axios
      .post(ClientURL.SAVE_CLIENT_CARE_PLAN, params, {
        headers: { Authorization: localStorage.getItem("loginToken") },
      })
      .then((res) => {
        if (res?.data?.status == "success") {
          AgencyStore.showAlert(
            "success",
            "Successfully Saved Client Care Plan"
          );

          ClientStore.setClientCareRecord(res?.data?.result);
          AgencyStore.setIsLoading(false);
          AgencyStore.setIsSaveLoading(true);
          handleClose();
        } else if (res?.data?.status == "failed") {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert("error", res?.data?.message);
        } else {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert("error", "Failed to Saved Client Care Plan");
        }
      })
      .catch((err) => {
        AgencyStore.setIsLoading(false);
        AgencyStore.showAlert("error", "Failed to Saved Client Care Plan");
      });
  };

  const updateClientCarePlan = (values) => {
    AgencyStore.setIsLoading(true);
    const params = {
      id: editData?.id,
      clientProfileId: clientId,
      visitType: values.visitType,
      detailedClientFunLimit: values.detailedClientFunLimit,
      pcaServices: values.pcaServices,
      rnSupervisorVisits: values.rnSupervisorVisits,
      goalOfServices: values.goalOfServices,
      objectivesOfServices: values.objectivesOfServices,
      dischargePlans: values.dischargePlans,
      ambulation: {
        specificActivitiesAllowed:
          values.specificActivitiesAllowed.length === 0
            ? []
            : typeof values.specificActivitiesAllowed === "string"
            ? values.specificActivitiesAllowed.split("\n")
            : values.specificActivitiesAllowed,
        transferSpecifics:
          values.transferSpecifics.length === 0
            ? []
            : typeof values.transferSpecifics === "string"
            ? values.transferSpecifics.split("\n")
            : values.transferSpecifics,
        equipmentToBeUsed:
          values.equipmentToBeUsed.length === 0
            ? []
            : typeof values.equipmentToBeUsed === "string"
            ? values.equipmentToBeUsed.split("\n")
            : values.equipmentToBeUsed,
        safetyNeeds:
          values.safetyNeeds.length === 0
            ? []
            : typeof values.safetyNeeds === "string"
            ? values.safetyNeeds.split("\n")
            : values.safetyNeeds,
      },
      personalCare: {
        bathingSpecifics:
          values.bathingSpecifics.length === 0
            ? []
            : typeof values.bathingSpecifics === "string"
            ? values.bathingSpecifics.split("\n")
            : values.bathingSpecifics,
        hairCareSpecifics:
          values.hairCareSpecifics.length === 0
            ? []
            : typeof values.hairCareSpecifics === "string"
            ? values.hairCareSpecifics.split("\n")
            : values.hairCareSpecifics,
        dressingSpecifics:
          values.dressingSpecifics.length === 0
            ? []
            : typeof values.dressingSpecifics === "string"
            ? values.dressingSpecifics.split("\n")
            : values.dressingSpecifics,
        skinCareSpecifics:
          values.skinCareSpecifics.length === 0
            ? []
            : typeof values.skinCareSpecifics === "string"
            ? values.skinCareSpecifics.split("\n")
            : values.skinCareSpecifics,
        nailCareSpecifics:
          values.nailCareSpecifics.length === 0
            ? []
            : typeof values.nailCareSpecifics === "string"
            ? values.nailCareSpecifics.split("\n")
            : values.nailCareSpecifics,
        oralCareSpecifics:
          values.oralCareSpecifics.length === 0
            ? []
            : typeof values.oralCareSpecifics === "string"
            ? values.oralCareSpecifics.split("\n")
            : values.oralCareSpecifics,
        shavingSpecifics:
          values.shavingSpecifics.length === 0
            ? []
            : typeof values.shavingSpecifics === "string"
            ? values.shavingSpecifics.split("\n")
            : values.shavingSpecifics,
      },
      elimination: {
        assistWithEliminationBy: values.assistWithEliminationBy,
        documentBm: values.documentBm,
      },
      nutrition: {
        assistWithMealPrepBy: values.assistWithMealPrepBy,
        remindPatientToTakeMedOf:
          values.remindPatientToTakeMedOf.length === 0
            ? []
            : typeof values.remindPatientToTakeMedOf === "string"
            ? values.remindPatientToTakeMedOf.split("\n")
            : values.remindPatientToTakeMedOf,
      },
      lightHouseKeepingTask: {
        cleaningToBePerformed:
          values.cleaningToBePerformed.length === 0
            ? []
            : typeof values.cleaningToBePerformed === "string"
            ? values.cleaningToBePerformed.split("\n")
            : values.cleaningToBePerformed,
        houseKeepingSpecifics:
          values.houseKeepingSpecifics.length === 0
            ? []
            : typeof values.houseKeepingSpecifics === "string"
            ? values.houseKeepingSpecifics.split("\n")
            : values.houseKeepingSpecifics,
      },
      transportation: {
        provideTransportationFor:
          values.provideTransportationFor.length === 0
            ? []
            : typeof values.provideTransportationFor === "string"
            ? values.provideTransportationFor.split("\n")
            : values.provideTransportationFor,
        carToBeUtilized:
          values.carToBeUtilized.length === 0
            ? []
            : typeof values.carToBeUtilized === "string"
            ? values.carToBeUtilized.split("\n")
            : values.carToBeUtilized,
      },
      homeManagement: {
        shopping:
          values.shopping.length === 0
            ? []
            : typeof values.shopping === "string"
            ? values.shopping.split("\n")
            : values.shopping,
        mealPlanning:
          values.mealPlanning.length === 0
            ? []
            : typeof values.mealPlanning === "string"
            ? values.mealPlanning.split("\n")
            : values.mealPlanning,
        billPaying:
          values.billPaying.length === 0
            ? []
            : typeof values.billPaying === "string"
            ? values.billPaying.split("\n")
            : values.billPaying,
        mealPrep:
          values.mealPrep.length === 0
            ? []
            : typeof values.mealPrep === "string"
            ? values.mealPrep.split("\n")
            : values.mealPrep,
      },
      pcaToReport: values.pcaToReport,
      otherInstructions: values.otherInstructions,
      copyOfPlanLeft: isChecked,
      clientWasInvolved: isChecked1,
    };
    axios
      .post(ClientURL.UPDATE_CLIENT_CARE_PLAN, params, {
        headers: { Authorization: localStorage.getItem("loginToken") },
      })
      .then((res) => {
        if (res?.data?.status == "success") {
          AgencyStore.showAlert(
            "success",
            "Successfully Update Client Care Plan"
          );
          AgencyStore.setIsLoading(false);
          AgencyStore.setIsSaveLoading(true);
          handleClose();
        } else if (res?.data?.status == "failed") {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert("error", res?.data?.message);
        } else {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert("error", "Failed to  Update Client Care Plan");
        }
      })
      .catch((err) => {
        AgencyStore.setIsLoading(false);
        AgencyStore.showAlert("error", "Failed to  Update Client Care Plan");
      });
  };

  const setProfileDataFormik = () => {
    formik.setValues({
      visitType: editData?.visitType || "",
      detailedClientFunLimit: editData?.detailedClientFunLimit || "",
      pcaServices: editData?.pcaServices || "",
      rnSupervisorVisits: editData?.rnSupervisorVisits || "",
      goalOfServices: editData?.goalOfServices || "",
      objectivesOfServices: editData?.objectivesOfServices || "",
      dischargePlans: editData?.dischargePlans || "",
      pcaToReport: editData?.pcaToReport || "",
      otherInstructions: editData?.otherInstructions || "",

      specificActivitiesAllowed:
        editData?.ambulation?.specificActivitiesAllowed || "",
      transferSpecifics: editData?.ambulation?.transferSpecifics || "",
      equipmentToBeUsed: editData?.ambulation?.equipmentToBeUsed || "",
      safetyNeeds: editData?.ambulation?.safetyNeeds || "",
      bathingSpecifics: editData?.personalCare?.bathingSpecifics || "",
      hairCareSpecifics: editData?.personalCare?.hairCareSpecifics || "",
      dressingSpecifics: editData?.personalCare?.dressingSpecifics || "",
      skinCareSpecifics: editData?.personalCare?.skinCareSpecifics || "",
      nailCareSpecifics: editData?.personalCare?.nailCareSpecifics || "",
      oralCareSpecifics: editData?.personalCare?.oralCareSpecifics || "",
      shavingSpecifics: editData?.personalCare?.shavingSpecifics || "",
      assistWithEliminationBy:
        editData?.elimination?.assistWithEliminationBy || "",
      documentBm: editData?.elimination?.documentBm || "",
      assistWithMealPrepBy: editData?.nutrition?.assistWithMealPrepBy || "",
      remindPatientToTakeMedOf:
        editData?.nutrition?.remindPatientToTakeMedOf || "",
      cleaningToBePerformed:
        editData?.lightHouseKeepingTask?.cleaningToBePerformed || "",
      houseKeepingSpecifics:
        editData?.lightHouseKeepingTask?.houseKeepingSpecifics || "",
      provideTransportationFor:
        editData?.transportation?.provideTransportationFor || "",
      carToBeUtilized: editData?.transportation?.carToBeUtilized || "",
      shopping: editData?.homeManagement?.shopping || "",
      mealPlanning: editData?.homeManagement?.mealPlanning || "",
      billPaying: editData?.homeManagement?.billPaying || "",
      mealPrep: editData?.homeManagement?.mealPrep || "",

      copyOfPlanLeft: isChecked,
      clientWasInvolved: isChecked1,
    });
  };

  return (
    <>
      <div className="homeSafetyContainer">
        <div className="underlineClick" onClick={handleClose}>
          Back
        </div>
        <div className="safetySelectInput">
          <div>Visit Type:</div>
          <div className="clientListinputFiled">
            <FormikController
              control="selects"
              error
              selectitem={nurseVisitType}
              {...formik.getFieldProps("visitType")}
              touch={formik.touched.visitType}
              errorname={formik.errors.visitType}
            />
          </div>
        </div>
      </div>
      <div className="medicationWrapper">
        <div className="medicationSection">
          <div className="heading">CLIENT CARE PLAN</div>
          <div className="detailWrapper">
            <Grid container spacing={2}>
              <Grid item xs={6} className="rowSection">
                <div className="nameList">Client's Name:</div>
                <div className="medicationForm">
                  <FormikController
                    value={
                      ClientStore.ClientAllData.client?.firstName +
                      "  " +
                      ClientStore.ClientAllData.client?.lastName
                    }
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>
              <Grid item xs={6} className="rowSection">
                <div className="nameList">MR#</div>
                <div className="medicationForm">
                  <FormikController
                    value={ClientStore.ClientAllData.client?.mra}
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>

              <Grid item xs={6} className="rowSection">
                <div className="nameDesc">Address:</div>
                <div className="medicationForm">
                  <FormikController
                    value={
                      ClientStore.ClientAllData.client?.clientAddress?.zipCode +
                      "  " +
                      ClientStore.ClientAllData.client?.clientAddress?.street +
                      "  " +
                      ClientStore.ClientAllData.client?.clientAddress?.state +
                      "  " +
                      ClientStore.ClientAllData.client?.clientAddress?.city
                    }
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>
              <Grid item xs={6} className="rowSection">
                <div className="nameDesc">PHONE #:</div>
                <div className="medicationForm">
                  <FormikController
                    value={ClientStore.ClientAllData.client?.phoneNo}
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>

              <Grid item xs={12} className="rowSection">
                <div className="nameDesc">DIAGNOSIS:</div>
                <div className="medicationForm">
                  <FormikController
                    value={diagnosisData}
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>

              <Grid item xs={12} className="rowSection">
                <div className="nameDesc">
                  Detailed client functional limitations:
                </div>
                <div className="medicationForm">
                  <div className="medicationForm">
                    <FormikController
                      name="detailedClientFunLimit"
                      // error
                      control="textfield"
                      multiline
                      rows={4}
                      {...formik.getFieldProps("detailedClientFunLimit")}
                      touch={formik.touched.detailedClientFunLimit}
                      errorname={formik.errors.detailedClientFunLimit}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} className="rowSection">
                <div className="nameDesc">SERVICES REQUIRED:</div>
              </Grid>

              <Grid item xs={12} className="rowSection">
                PCA services: Days/Start Times/Duration to receive services:
                <div className="medicationForm">
                  <div className="medicationForm">
                    <FormikController
                      name="pcaServices"
                      // error
                      control="textfield"
                      multiline
                      rows={4}
                      {...formik.getFieldProps("pcaServices")}
                      touch={formik.touched.pcaServices}
                      errorname={formik.errors.pcaServices}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className="rowSection">
                <div className="nameDesc">RN Supervisor visits:</div>
                <div className="medicationForm">
                  <div className="medicationForm">
                    <FormikController
                      name="rnSupervisorVisits"
                      variant="standard"
                      // error
                      control="textfield"
                      {...formik.getFieldProps("rnSupervisorVisits")}
                      touch={formik.touched.rnSupervisorVisits}
                      errorname={formik.errors.rnSupervisorVisits}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className="rowSection">
                <div className="nameDesc">Goals of services:</div>
                <div className="medicationForm">
                  <div className="medicationForm">
                    <FormikController
                      name="goalOfServices"
                      multiline
                      rows={4}
                      // error
                      control="textfield"
                      {...formik.getFieldProps("goalOfServices")}
                      touch={formik.touched.goalOfServices}
                      errorname={formik.errors.goalOfServices}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className="rowSection">
                <div className="nameDesc">Objectives of services:</div>
                <div className="medicationForm">
                  <div className="medicationForm">
                    <FormikController
                      name="objectivesOfServices"
                      multiline
                      rows={4}
                      // error
                      control="textfield"
                      {...formik.getFieldProps("objectivesOfServices")}
                      touch={formik.touched.objectivesOfServices}
                      errorname={formik.errors.objectivesOfServices}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className="rowSection">
                <div className="nameDesc">Discharge plans: </div>
                <div className="medicationForm">
                  <div className="medicationForm">
                    <FormikController
                      name="dischargePlans"
                      variant="standard"
                      // error
                      control="textfield"
                      {...formik.getFieldProps("dischargePlans")}
                      touch={formik.touched.dischargePlans}
                      errorname={formik.errors.dischargePlans}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>

          <TableContainer>
            <Table className="table" size="small">
              <TableHead></TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    className="tablecell"
                    sx={headerTextStyles}
                    colSpan={3}
                  >
                    AMBULATION/TRANSFER
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tablecell">
                    Specific activities allowed (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="specificActivitiesAllowed"
                      rows={3}
                      {...formik.getFieldProps("specificActivitiesAllowed")}
                      touch={formik.touched.specificActivitiesAllowed}
                      errorname={formik.errors.specificActivitiesAllowed}
                    />
                    Transfer specifics (list)
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="transferSpecifics"
                      rows={3}
                      {...formik.getFieldProps("transferSpecifics")}
                      touch={formik.touched.transferSpecifics}
                      errorname={formik.errors.transferSpecifics}
                    />
                  </TableCell>

                  <TableCell className="tablecell">
                    Equipment to be used (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="equipmentToBeUsed"
                      rows={3}
                      {...formik.getFieldProps("equipmentToBeUsed")}
                      touch={formik.touched.equipmentToBeUsed}
                      errorname={formik.errors.equipmentToBeUsed}
                    />
                  </TableCell>
                  <TableCell className="tablecell">
                    Safety needs (list)
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="safetyNeeds"
                      rows={3}
                      {...formik.getFieldProps("safetyNeeds")}
                      touch={formik.touched.safetyNeeds}
                      errorname={formik.errors.safetyNeeds}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className="tablecell"
                    sx={headerTextStyles}
                    colSpan={3}
                  >
                    PERSONAL CARE
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tablecell">
                    Bathing specifics (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="bathingSpecifics"
                      rows={3}
                      {...formik.getFieldProps("bathingSpecifics")}
                      touch={formik.touched.bathingSpecifics}
                      errorname={formik.errors.bathingSpecifics}
                    />
                    Hair care specifics (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="hairCareSpecifics"
                      rows={3}
                      {...formik.getFieldProps("hairCareSpecifics")}
                      touch={formik.touched.hairCareSpecifics}
                      errorname={formik.errors.hairCareSpecifics}
                    />
                    Dressing specifics (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="dressingSpecifics"
                      rows={3}
                      {...formik.getFieldProps("dressingSpecifics")}
                      touch={formik.touched.dressingSpecifics}
                      errorname={formik.errors.dressingSpecifics}
                    />
                  </TableCell>

                  <TableCell className="tablecell">
                    Skin care specifics (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="skinCareSpecifics"
                      rows={3}
                      {...formik.getFieldProps("skinCareSpecifics")}
                      touch={formik.touched.skinCareSpecifics}
                      errorname={formik.errors.skinCareSpecifics}
                    />
                    Nail care specifics (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="nailCareSpecifics"
                      rows={3}
                      {...formik.getFieldProps("nailCareSpecifics")}
                      touch={formik.touched.nailCareSpecifics}
                      errorname={formik.errors.nailCareSpecifics}
                    />
                  </TableCell>
                  <TableCell className="tablecell">
                    Oral care specifics (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="oralCareSpecifics"
                      rows={3}
                      {...formik.getFieldProps("oralCareSpecifics")}
                      touch={formik.touched.oralCareSpecifics}
                      errorname={formik.errors.oralCareSpecifics}
                    />
                    Shaving specifics (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="shavingSpecifics"
                      rows={3}
                      {...formik.getFieldProps("shavingSpecifics")}
                      touch={formik.touched.shavingSpecifics}
                      errorname={formik.errors.shavingSpecifics}
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    className="tablecell"
                    sx={headerTextStyles}
                    colSpan={3}
                  >
                    ELIMINATION
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tablecell" colSpan={2}>
                    Assist with elimination by:
                    <FormikController
                      control="textfield"
                      variant="standard"
                      name="assistWithEliminationBy"
                      {...formik.getFieldProps("assistWithEliminationBy")}
                      touch={formik.touched.assistWithEliminationBy}
                      errorname={formik.errors.assistWithEliminationBy}
                    />
                  </TableCell>

                  <TableCell className="tablecell">
                    Document BM
                    <FormikController
                      control="textfield"
                      variant="standard"
                      name="documentBm"
                      {...formik.getFieldProps("documentBm")}
                      touch={formik.touched.documentBm}
                      errorname={formik.errors.documentBm}
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    className="tablecell"
                    sx={headerTextStyles}
                    colSpan={3}
                  >
                    NUTRITION
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tablecell" colSpan={2}>
                    Assist with eating/meal prep by:
                    <FormikController
                      control="textfield"
                      variant="standard"
                      name="assistWithMealPrepBy"
                      {...formik.getFieldProps("assistWithMealPrepBy")}
                      touch={formik.touched.assistWithMealPrepBy}
                      errorname={formik.errors.assistWithMealPrepBy}
                    />
                  </TableCell>

                  <TableCell className="tablecell">
                    Remind Patient to take medications of (list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="remindPatientToTakeMedOf"
                      rows={3}
                      {...formik.getFieldProps("remindPatientToTakeMedOf")}
                      touch={formik.touched.remindPatientToTakeMedOf}
                      errorname={formik.errors.remindPatientToTakeMedOf}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className="tablecell"
                    sx={headerTextStyles}
                    colSpan={3}
                  >
                    LIGHT HOUSEKEEPING TASKS
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tablecell" colSpan={2}>
                    Cleaning to be performed (list specifics):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="cleaningToBePerformed"
                      rows={3}
                      {...formik.getFieldProps("cleaningToBePerformed")}
                      touch={formik.touched.cleaningToBePerformed}
                      errorname={formik.errors.cleaningToBePerformed}
                    />
                  </TableCell>

                  <TableCell className="tablecell">
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="houseKeepingSpecifics"
                      rows={3}
                      {...formik.getFieldProps("houseKeepingSpecifics")}
                      touch={formik.touched.houseKeepingSpecifics}
                      errorname={formik.errors.houseKeepingSpecifics}
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    className="tablecell"
                    sx={headerTextStyles}
                    colSpan={3}
                  >
                    TRANSPORTATION
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tablecell" colSpan={2}>
                    Provide transportation for (list specifics)
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="provideTransportationFor"
                      rows={3}
                      {...formik.getFieldProps("provideTransportationFor")}
                      touch={formik.touched.provideTransportationFor}
                      errorname={formik.errors.provideTransportationFor}
                    />
                  </TableCell>

                  <TableCell className="tablecell">
                    Car to be utilized(list):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="carToBeUtilized"
                      rows={3}
                      {...formik.getFieldProps("carToBeUtilized")}
                      touch={formik.touched.carToBeUtilized}
                      errorname={formik.errors.carToBeUtilized}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className="tablecell"
                    sx={headerTextStyles}
                    colSpan={3}
                  >
                    HOME MANAGEMENT
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tablecell" colSpan={2}>
                    Shopping (list specifics):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="shopping"
                      rows={3}
                      {...formik.getFieldProps("shopping")}
                      touch={formik.touched.shopping}
                      errorname={formik.errors.shopping}
                    />
                    Meal planning (list specifics):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="mealPlanning"
                      rows={3}
                      {...formik.getFieldProps("mealPlanning")}
                      touch={formik.touched.mealPlanning}
                      errorname={formik.errors.mealPlanning}
                    />
                  </TableCell>

                  <TableCell className="tablecell">
                    Bill paying (list specifics):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="billPaying"
                      rows={3}
                      {...formik.getFieldProps("billPaying")}
                      touch={formik.touched.billPaying}
                      errorname={formik.errors.billPaying}
                    />
                    Meal Prep (list specifics):
                    <FormikController
                      control="textfield"
                      variant="standard"
                      multiline
                      name="mealPrep"
                      rows={3}
                      {...formik.getFieldProps("mealPrep")}
                      touch={formik.touched.mealPrep}
                      errorname={formik.errors.mealPrep}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid container spacing={2}>
            PCA to report the following client changes to the RN:
            <Grid item xs={12} className="rowSection">
              <div className="nameDesc">Changes in vital signs: </div>
              <div className="medicationForm">
                <div className="medicationForm">
                  <FormikController
                    name="pcaToReport"
                    // error
                    control="textfield"
                    multiline
                    rows={4}
                    {...formik.getFieldProps("pcaToReport")}
                    touch={formik.touched.pcaToReport}
                    errorname={formik.errors.pcaToReport}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} className="rowSection">
              <div className="nameDesc">Other Instructions: </div>
              <div className="medicationForm">
                <div className="medicationForm">
                  <FormikController
                    name="otherInstructions"
                    // error
                    control="textfield"
                    variant="standard"
                    {...formik.getFieldProps("otherInstructions")}
                    touch={formik.touched.otherInstructions}
                    errorname={formik.errors.otherInstructions}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} className="rowSection">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => handleCheckboxChange("copyOfPlanLeft")}
              />
              Copy of Plan left in the home for the agency staff to follow.
            </Grid>
            <Grid item xs={12} className="rowSection">
              <input
                type="checkbox"
                checked={isChecked1}
                onChange={() => handleCheckboxChange("clientWasInvolved")}
              />
              Client was involved in the development of this plan.
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <div className="formButtonSave">
              <ConfirmPopUp
                buttonLabel={type == "save" ? "Save " : "Update"}
                title={type == "save" ? "Save " : "Update"}
                content=" Please confirm your decision below."
                onConfirm={() => {
                  if (type == "save") {
                    handlesaveUpadateState("save");
                  } else {
                    handlesaveUpadateState("update");
                  }
                  formik.handleSubmit();
                }}
                clickHTML={
                  <FormikController
                    control="buttons"
                    name={
                      type == "save"
                        ? "Save Client Care Plan"
                        : "Update  Client Care Plan"
                    }
                    className="buttonSelectedGreen fixedWidth"
                    fullWidth="false"
                  />
                }
              />
            </div>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default AddClientCarePlan;
